export default __webpack_public_path__ + "static/media/factory__13.29a8b011.jpg";